import Alpine from 'alpinejs'

Alpine.store('MobileMenu', {
  isOpen: false,

  open() {
    this.isOpen = true
  },

  close() {
    this.isOpen = false
  },
})
